import React from 'react'
import styled from 'styled-components'
import {
  CopyrightUserRole,
  CopyrightUserType,
  FollowStatus,
} from '~/graphqls/types'
import { MyImage } from '~/components/ui/MyImage'
import Link from 'next/link'
import UserBadge from './UserBadge'
import FollowBtn from './FollowBtn'
import { VipIcon } from '~/components/icon/Vip'

const StyledSingleCreator = styled.div`
  border: 1px solid ${props => props.theme.light1};
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 32px;
  background: ${props => props.theme.light3};
  .creator-bg {
    border-radius: 8px;
    height: 112px;
  }
  .creator-avatar-wrap {
    position: relative;
    margin: -34px auto 16px;
    text-align: center;
    height: 64px;
    width: 64px;
  }
  .creator-avatar {
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: 2px solid ${props => props.theme.light3};
  }

  .creator-name {
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    color: ${props => props.theme.dark2};
  }
  .creator-desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    height: 40px;
    color: ${props => props.theme.dark4};
    /* TODO 抽离成mixins */
    word-break: break-all;
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    /*! autoprefixer: ignore next */
    -webkit-box-orient: vertical;
    text-align: center;
  }
`

interface User {
  base?: {
    uid?: number
  } | null
  userRoleInfo: {
    artist: boolean | null
    aiArtist: boolean | null
  } | null
  backgroundUrl?: string | null
  avatarUrl?: string | null
  userRole?: CopyrightUserRole | null
  userType?: CopyrightUserType | null
  nickname?: string | null
  personalizedSignature?: string | null
  social?: {
    followStatus?: FollowStatus | null
  } | null
}

export const UserCard: React.FC<{
  data: User
  style?: React.CSSProperties
}> = ({ data, style }) => {
  return (
    <StyledSingleCreator style={style}>
      <Link href={`/user/${data.base?.uid}`}>
        <a>
          <MyImage
            tag="v1200"
            className="creator-bg"
            src={data.backgroundUrl}
          />
          <div className="creator-avatar-wrap">
            <MyImage
              tag="v400"
              className="creator-avatar"
              src={data.avatarUrl}
            />
            <VipIcon
              userRole={data?.userRoleInfo}
              className="h-6 -right-1  max-w-[36px]"
            />
          </div>
          <div className="creator-name flex items-center justify-center">
            <span className="text-overflow">{data?.nickname}</span>
            <UserBadge
              type={data?.userType}
              className="ml-1 !w-[14px] !h-[14px] flex-shrink-0"
            />
          </div>
          <div className="text-center my-2">
            <FollowBtn
              targetId={data.base?.uid}
              status={data.social?.followStatus}
            />
          </div>
          <div className="creator-desc">
            {data?.personalizedSignature || '这个人很懒，什么都没有留下'}
          </div>
        </a>
      </Link>
    </StyledSingleCreator>
  )
}
